<bw-action-article-legacy [brightsideWebFb]="{ event_name: 'contest-amoe' }" [minHeight]="0" [edgeToEdge]="false">
  <div header-title>
    <bw-header-legacy
      [eyebrow]="true"
      [title]="'CONTEST_AMOE_LEGAL_SUB_TITLE' | translate"
      [description]="'CONTEST_AMOE_LEGAL_TITLE' | translate"
    >
    </bw-header-legacy>
  </div>
  <div content-section>
    <p
      text-large-regular
      color="var(--secondary-text)"
      class="mb-sm"
      [innerHTML]="'CONTEST_AMOE_LEGAL_CONTENT_SUB_TITLE' | translate"
    ></p>
    <bw-cell-legacy [separatorType]="'full'" [contentLeft]="true" [contentRight]="true">
      <ng-container content-left>
        <p text-large-regular class="truncate-line">{{ 'CONTEST_AMOE_LEGAL_CONTENT_FNAME_LABEL' | translate }}</p>
      </ng-container>

      <ng-container content-right>
        <p text-large-regular class="truncate-line">{{ clientDetails.fName | translate }}</p>
      </ng-container>
    </bw-cell-legacy>
    <bw-cell-legacy [separatorType]="'full'" [contentLeft]="true" [contentRight]="true">
      <ng-container content-left>
        <p text-large-regular class="truncate-line">{{ 'CONTEST_AMOE_LEGAL_CONTENT_LNAME_LABEL' | translate }}</p>
      </ng-container>

      <ng-container content-right>
        <p text-large-regular class="truncate-line">{{ clientDetails.lName | translate }}</p>
      </ng-container>
    </bw-cell-legacy>
    <bw-cell-legacy [separatorType]="'full'" [contentLeft]="true" [contentRight]="true">
      <ng-container content-left>
        <p text-large-regular class="truncate-line">{{ 'CONTEST_AMOE_LEGAL_CONTENT_PHONE_LABEL' | translate }}</p>
      </ng-container>

      <ng-container content-right>
        <p text-large-regular class="truncate-line">{{ clientDetails.phone | translate }}</p>
      </ng-container>
    </bw-cell-legacy>
  </div>
</bw-action-article-legacy>
